import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";
import { createCookie, readCookie } from "../../utils/helpers";
import FunnelStepTypes from "../funnel-step/types";

const searchUser = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.searchUserByEmailAndAccountNumber(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const sendRefundRequest = (userGuid) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.sendRefundRequest(userGuid)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { searchUser, sendRefundRequest };
